import isomorphicRoute from '@client/helperComponents/isomorphicRoute';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import Loader from '@client/components/loader/Loader';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

export const routesDonation = {
  path: '/donera/*',
  componentPath: 'pages/donatePage/DonatePage',
  Component: isomorphicRoute(
    () => import('pages/donatePage/DonatePage'),
    options
  ),
  routes: [
    {
      path: 'error/*',
      componentPath: 'pages/donatePage/donateErrorRoute/DonateErrorRoute',
      Component: isomorphicRoute(
        () => import('pages/donatePage/donateErrorRoute/DonateErrorRoute'),
        options
      ),
    },
    {
      path: ':fundraiserId',
      componentPath:
        'pages/donatePage/donateFundraiserRoute/DonateFundraiserRoute',
      Component: isomorphicRoute(
        () =>
          import(
            'pages/donatePage/donateFundraiserRoute/DonateFundraiserRoute'
          ),
        options
      ),
    },
    {
      path: ':donationId/tack',
      componentPath: 'pages/donatePage/donateThankYouRoute/DonateThankYouRoute',
      Component: isomorphicRoute(
        () =>
          import('pages/donatePage/donateThankYouRoute/DonateThankYouRoute'),
        options
      ),
    },
  ],
};
